import Vue from 'vue';
import VueRouter from 'vue-router';
import subs from './routes';

const Login     = () => import('../views/login');
const Layout    = () => import('../views/layout');
const LayoutV   = () => import('../views/layoutV');
// const Home      = () => import('../views/home');

Vue.use(VueRouter);

const routes = [{
    name: 'login',
    path: '/login',
    component: Login
}, {
    name: 'layout',
    path: '/',
    component: Layout,
    children: subs
}, {
    name: 'layoutv',
    path: '/v',
    component: LayoutV,  // (resolve) => require(['../views/layout'], resolve),
    // redirect: 'home',
    children: subs
}];

const router = new VueRouter({
    // mode:'history', //这样url就没有/#/XXX,而是常见的url形式
    // base: process.env.BASE_URL,
    routes: routes, // short for routes: routes
    // linkActiveClass:'active',     //router-link的选中状态的class，也有一个默认的值
    // history:true
});

export default router
